<template>
  <div class="input">
    <div class="input-label">パスワード</div>
    <div class="input-group">
      <input
        type="text"
        class="input-text"
        v-model="password"
        :placeholder="placeholderPassword">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    placeholderPassword: function () {
      if (this.$route.name == 'user-new') {
        return 'パスワードは必須です。'
      } else if (this.$route.name == 'user-edit') {
        return '変更する場合のみ入力してください。'
      }
      return ''
    },

    password: {
      get: function () {
        return this.$store.state.user.password
      },
      set: function (value) {
        this.$store.commit(
          'user/setPassword',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
